import React from "react";
import AdminMenu from "./AdminMenu";
import AdminHeader from "./AdminHeader";

const stats = [
    { title: "DAU", value: "4,582", color: "text-blue-600" },
    { title: "WAU", value: "18,924", color: "text-green-600" },
    { title: "MAU", value: "62,315", color: "text-purple-600" },
    { title: "Avg Session", value: "14m 28s", color: "text-orange-600" }
];

const metrics = [
    {
        title: "Average Lesson Level",
        value: "17.8"
    },
    {
        title: "Median Lesson Level",
        value: "15"
    },
    {
        title: "Lesson Completion",
        value: "82%"
    },
    {
        title: "Average Mistakes",
        value: "2.4"
    },
    {
        title: "Average Duration",
        value: "6m 12s"
    },
    {
        title: "Abandon Rate",
        value: "13%"
    }
];

const hardestLessons = [
    {
        lesson: "HTML Lists",
        mistakes: "4.3"
    },
    {
        lesson: "CSS Flexbox",
        mistakes: "3.8"
    },
    {
        lesson: "JavaScript Variables",
        mistakes: "3.4"
    },
    {
        lesson: "Python Loops",
        mistakes: "2.9"
    }
];

const topCourses = [
    {
        course: "HTML",
        users: "12,483"
    },
    {
        course: "CSS",
        users: "10,922"
    },
    {
        course: "JavaScript",
        users: "8,411"
    },
    {
        course: "Python",
        users: "5,632"
    }
];

const AdminAnalytics = () => {
    return (
        <div className="flex flex-1 bg-gray-50 min-h-screen">
            <div className="w-1/5">
                <AdminMenu path="./" />
            </div>

            <div className="flex-grow w-4/5">
                <AdminHeader title="داشبورد" />

                <div className="p-8 space-y-8">

                    {/* Top Stats */}

                    <div className="grid grid-cols-4 gap-6">
                        {stats.map((item) => (
                            <div
                                key={item.title}
                                className="bg-white rounded-2xl shadow-sm border p-6"
                            >
                                <p className="text-gray-500 text-sm">
                                    {item.title}
                                </p>

                                <h2 className={`text-4xl font-bold mt-3 ${item.color}`}>
                                    {item.value}
                                </h2>
                            </div>
                        ))}
                    </div>

                    {/* Metrics */}

                    <div className="grid grid-cols-3 gap-6">
                        {metrics.map((item) => (
                            <div
                                key={item.title}
                                className="bg-white rounded-2xl shadow-sm border p-5"
                            >
                                <p className="text-gray-500">
                                    {item.title}
                                </p>

                                <h3 className="text-3xl font-bold mt-2">
                                    {item.value}
                                </h3>
                            </div>
                        ))}
                    </div>

                    {/* Charts */}

                    <div className="grid grid-cols-2 gap-6">

                        <div className="bg-white rounded-2xl shadow-sm border p-6">
                            <h2 className="font-semibold text-lg mb-5">
                                Lesson Attempts
                            </h2>

                            <div className="h-72 rounded-xl bg-gradient-to-r from-blue-100 to-indigo-100 flex items-center justify-center text-gray-500">
                                Chart Placeholder
                            </div>
                        </div>

                        <div className="bg-white rounded-2xl shadow-sm border p-6">
                            <h2 className="font-semibold text-lg mb-5">
                                Daily Active Users
                            </h2>

                            <div className="h-72 rounded-xl bg-gradient-to-r from-green-100 to-emerald-100 flex items-center justify-center text-gray-500">
                                Chart Placeholder
                            </div>
                        </div>

                    </div>

                    {/* Tables */}

                    <div className="grid grid-cols-2 gap-6">

                        <div className="bg-white rounded-2xl shadow-sm border">
                            <div className="p-5 border-b font-semibold">
                                Hardest Lessons
                            </div>

                            <table className="w-full">
                                <thead className="text-left text-gray-500 text-sm">
                                <tr>
                                    <th className="p-4">Lesson</th>
                                    <th className="p-4">Avg Mistakes</th>
                                </tr>
                                </thead>

                                <tbody>
                                {hardestLessons.map((item) => (
                                    <tr
                                        key={item.lesson}
                                        className="border-t"
                                    >
                                        <td className="p-4">
                                            {item.lesson}
                                        </td>

                                        <td className="p-4 font-semibold">
                                            {item.mistakes}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-white rounded-2xl shadow-sm border">
                            <div className="p-5 border-b font-semibold">
                                Most Active Courses
                            </div>

                            <table className="w-full">
                                <thead className="text-left text-gray-500 text-sm">
                                <tr>
                                    <th className="p-4">Course</th>
                                    <th className="p-4">Users</th>
                                </tr>
                                </thead>

                                <tbody>
                                {topCourses.map((item) => (
                                    <tr
                                        key={item.course}
                                        className="border-t"
                                    >
                                        <td className="p-4">
                                            {item.course}
                                        </td>

                                        <td className="p-4 font-semibold">
                                            {item.users}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
};

export default AdminAnalytics;